module.exports = {
  src: __webpack_public_path__ + "animate-pill-40728cb3642921a0dba230530c7ebd2e.svg",
  width: 129,
  height: 129,
  bytes: 3228,
  type: "svg",
};
module.exports.toString = function() {
  return __webpack_public_path__ + "animate-pill-40728cb3642921a0dba230530c7ebd2e.svg";
};